import React from "react";
import { translate } from "../Services/translation";

const ReadMore = ({ data }) => {
  const { text } = data,
        toScroll = document.getElementById('toscroll'),
        scrollToSubcatagory = () => {
          toScroll.scrollIntoView({
              behavior: 'smooth', 
              block: 'start', 
              inline: 'nearest'
          });
        }

  return (
    <p className={"more-description__all"}>
      <span dangerouslySetInnerHTML={{ __html: text }}></span>
      {toScroll && <span onClick={scrollToSubcatagory} className="read-or-hide">
        <strong>{translate("common.readmore")}</strong>
      </span>}
    </p>
  );
};

export default ReadMore;
